<template>
  <div>
    <button
      :id="'_slider_button' + listing_id"
      tabindex="0"
      @click="openPhoto(0)"
      @keyup.enter="openPhoto(0)"
      aria-label="Press enter to browse photos of this property"
    >
      <svg-vue
        icon="slideshow"
        class="fill-current h-10 w-10 p-2.5 bg-primary bg-opacity-90 hover:bg-opacity-100 hover:text-white rounded"
        :class="{ 'text-accent': popupOpen, 'text-white/50': !popupOpen }"
      ></svg-vue>
    </button>

    <teleport to="#popup-target">
      <div v-if="popupOpen" class="fixed top-0 z-[999] h-screen w-full bg-white dark:bg-primary-dark/60 backdrop-blur-xl flex flex-col justify-center" >
        <div class="w-full h-full flex flex-col">

          <span @click="closePhotoBrowser()" @keydown.enter="closePhotoBrowser()" class="absolute text-white flex items-center leading-none h-10 px-6 bg-accent border-4 border-primary shadow-xl right-4 top-4 lg:right-8 cursor-pointer uppercase text-sm" tabindex="4" >
            <svg-vue icon="times" class="fill-current h-4 w-4 mr-2"></svg-vue>
            close
          </span>

          <div class="flex-grow lg:h-full w-full flex justify-center items-center py-20 lg:py-8">
            <img
              tabindex="1"
              id="activephoto"
              @keydown.esc="closePhotoBrowser()"
              @keydown.enter="nextPhoto"
              :src="activePhoto.url"
              :alt="'Photo ' + (activeIndex+1) + ' of ' + photos.length + ' (use the enter key to advance photos and esc to close gallery)'"
              class="max-h-full max-w-full mx-auto shadow-xl"
            >
          </div>

          <div class="absolute bottom-0 px-4 pb-20 z-20 h-32 w-full flex justify-center" >
            <div class="w-full h-full sm:max-w-xs mx-auto bg-white dark:bg-primary dark:text-white shadow-xl flex justify-between p-1" >
              <span @click="prevPhoto" class="leading-none h-10 px-6 bg-accent text-white flex items-center cursor-pointer uppercase text-sm" >
                <svg-vue icon="angle-left" class="fill-current h-4 w-4 mr-2"></svg-vue>
                <span class="sr-only">prev</span>
              </span>
              <span class="text-blue font-bold flex items-center leading-none"> {{ activeIndex + 1 }} of {{ photoData.length }}</span>
              <span @click="nextPhoto" class="leading-none h-10 px-6 bg-accent text-white flex items-center cursor-pointer uppercase text-sm" >
                <span class="sr-only">next</span>
                <svg-vue icon="angle-right" class="fill-current h-4 w-4 ml-2"></svg-vue>
              </span>
            </div>
          </div>

        </div>

      </div>
    </teleport>
  </div>
</template>

<script>
export default {
 name: 'MiniPhotoSlider',

  props: {
    photos: {
      type: Object,
      default: () => {}
    },
    listing_id: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      activePhoto: {},
      photoData: [],
      popupOpen: false,
      activeIndex: 0
    }
  },

  mounted () {
    this.photoData = this.photos
  },

  methods: {
    openPhoto (num) {
      this.popupOpen = true
      this.activeIndex = num
      this.activePhoto = this.photoData[num]

      this.$nextTick(() => {
        document.getElementById('activephoto').focus()
      })

      dataLayer.push({
        'event': 'user_action',
        'action_name': 'Open Photo Slider'
      })
    },

    nextPhoto () {
      if((this.activeIndex+1) == this.photoData.length){
        this.activeIndex = 0
      } else {
        this.activeIndex++
      }

      this.openPhoto(this.activeIndex)
    },

    prevPhoto () {
      if((this.activeIndex+1) == 1){
        this.activeIndex = this.photoData.length
      } else {
        this.activeIndex--
      }

      this.openPhoto(this.activeIndex)
    },

    closePhotoBrowser () {
      this.popupOpen = false

      this.$nextTick(() => {
        document.getElementById('_slider_button' + this.listing_id).focus()
      })
    }
  }
}
</script>
